import React from 'react';

function Email({ color }: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.806"
      height="15.045"
      viewBox="0 0 18.806 15.045"
    >
      <path
        fill={color || '#4d5153'}
        d="M20.806 5.881A1.886 1.886 0 0018.926 4H3.881A1.886 1.886 0 002 5.881v11.284a1.886 1.886 0 001.881 1.881h15.045a1.886 1.886 0 001.881-1.881zm-1.881 0l-7.523 4.7-7.523-4.7zm0 11.284H3.881v-9.4l7.523 4.7 7.523-4.7z"
        data-name="Path 2865"
        transform="translate(-2 -4)"
      ></path>
    </svg>
  );
}

export default Email;
